var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"articles-contributors"},_vm._l((_vm.cmps),function(cmp){return _c('AnalysisTable',_vm._b({key:cmp.id},'AnalysisTable',cmp,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }